<mat-icon [svgIcon]="svgIcon" color="accent" />
<span>{{ taskTitle !== '' ? taskTitle : ('FIDUCIARY.tasks.columns.title.empty' | translate) }}</span>
